const ZOHO_RECRUIT_OAUTH_SCOPE =
  "ZohoRecruit.settings.READ,ZohoRecruit.users.READ,ZohoRecruit.modules.READ,ZohoRecruit.modules.WRITE,ZohoRecruit.modules.UPDATE";

const ZOHO_RECRUIT_OAUTH_SERVER = "https://accounts.zoho.com";

const LEVER_HIRE_OAUTH_SCOPE =
  "offline_access contact:read:admin feedback:write:admin feedback_templates:write:admin files:write:admin notes:write:admin opportunities:write:admin postings:read:admin resumes:read:admin stages:read:admin tags:read:admin webhooks:write:admin";


// const LEVER_HIRE_OAUTH_SERVER = "https://sandbox-lever.auth0.com";
const LEVER_HIRE_OAUTH_SERVER = "https://auth.lever.co/authorize ";

export {
  ZOHO_RECRUIT_OAUTH_SCOPE,
  ZOHO_RECRUIT_OAUTH_SERVER,
  LEVER_HIRE_OAUTH_SCOPE,
  LEVER_HIRE_OAUTH_SERVER,
};
